<template lang="pug">
</template>

<script>
import CSRF from 'csrf'

export default {
  name: 'FootprintTracker',
  props: {
    footprintableId: { type: String, required: true },
    footprintableType: { type: String, required: true }
  },
  computed: {
    url() {
      return `/api/footprints.json`
    },
    payload() {
      return {
        footprintable_type: this.footprintableType,
        footprintable_id: this.footprintableId
      }
    }
  },
  created() {
    this.sendFootprint()
  },
  methods: {
    sendFootprint() {
      fetch(this.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': CSRF.getToken()
        },
        credentials: 'same-origin',
        body: JSON.stringify(this.payload)
      })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok')
        return response.json()
      })
      .then(json => {
        // 足跡記録成功 → 何も表示しない
        console.log('Footprint logged:', json)
      })
      .catch(error => {
        console.warn('Footprint failed:', error)
      })
    }
  }
}
</script>
